<template>
  <div class="login">
    <div class="content">
      <div class="info">
        <!-- <div v-if="!forgetPasswordShow && !verificationCodeShow && !newPasswordShow && !resetSuccessShow" class="info_left">
          <div class="operating">
            <p class="top-titles">{{ $t("sign_up") }}</p>
            <p class="save_time" style="font-weight: 600">
              {{ $t("save_time_later1") }}
            </p>
            <p class="save_time">{{ $t("save_time_later2") }}</p>
            <button @click="goToRegister()" class="create_btn">
              {{ $t("createAccount") }}
            </button>
          </div>
        </div> -->

        <div v-if="!forgetPasswordShow && !verificationCodeShow && !newPasswordShow && !resetSuccessShow" class="info_right">
          <div class="operating">
            <p class="top-titles">{{ $t("log_in") }}</p>
            <p
              v-if="loginErrorMessage"
              style="padding-bottom: 20px; color: red"
            >
              <b>{{ loginErrorMessage }}</b>
            </p>
            <!-- <p v-if="newPasswordResetMessage" style="padding:10px; border: 1px, solid rgb(3, 211, 252)">
              <h3>{{ newPasswordResetMessage }}</h3>
            </p> -->
            <div class="input_box input_box_top">
              <span>{{ $t("userName") }}</span>
              <el-input
                :class="[(this.loginErrorEmail && !formLabelAlign.username) ? 'el-input-error' : 'el-input']"
                v-model="formLabelAlign.username"
                :placeholder="[this.loginErrorEmail ? this.loginErrorEmail : $t('enter_user_name')]"
              ></el-input>
              <span style="font-size: 14px; color: #999">{{ $t("phoneFormatD") }}</span>
            </div>
            <div class="input_box">
              <span>{{ $t("password") }}</span>
              <el-input
                :class="[
                  (this.loginErrorPassword && !formLabelAlign.password) ? 'el-input-error' : 'el-input',
                ]"
                v-model="formLabelAlign.password"
                type="password"
                :placeholder="[this.loginErrorPassword ? this.loginErrorPassword : $t('enter_password')]"
              ></el-input>
              <!-- <span class="forgot-pw" @click="onEnableForgotPassword">{{
                $t("forgotPassword")
              }}</span> -->
            </div>
            <button @click="Login(formLabelAlign)">{{ $t("logIn") }}</button>
          </div>

          <!-- <div class="or-line">
            <span>{{ $t("or") }}</span>
          </div> -->

          <!-- <div class="login-types">
            <img
              @click="logInWithMedia('wechat')"
              src="../assets/img/login_type_wechat.png"
              alt=""
            />
            <img
              @click="logInWithMedia('facebook')"
              src="../assets/img/login_type_facebook.png"
              alt=""
            />
            <img
              @click="logInWithMedia('google')"
              src="../assets/img/login_type_google.png"
              alt=""
            />
            <img
              @click="logInWithMedia('phone')"
              src="../assets/img/login_type_phone.png"
              alt=""
            />
          </div> -->
          <!-- <div class="operating account" v-show="login===false">
            <p>{{ $t('resetSendEmail') }}</p>
            <p v-if="couldNotFindEmail" style="color: red">{{ $t('noAccountWithEmail') }}</p>
            <div class="input_box">
              <el-input v-model="email" placeholder="Email"></el-input>
            </div>
              <button @click="resetEmailRequest(email)" class="login_btn">{{ $t('submit') }}</button>
              <button @click="ForgotPassword" class="login_btn">{{ $t('cancel') }}</button>
          </div> -->
        </div>

        <div v-if="forgetPasswordShow || verificationCodeShow || newPasswordShow || resetSuccessShow" class="info_right_forgot">
          <p class="top-titles">{{ $t("reset_password") }}</p>
          <div v-if="forgetPasswordShow" class="operating">
            <p class="forgot-text">{{ $t("reset_password_text") }}</p>
            <p v-if="true" class="server-error-msg">
              <b>{{ this.resetErrorEmail }}</b>
            </p>
            <div class="input_box">
              <span>{{ $t("email") }}</span>
              <el-input
                :class="[(this.resetErrorEmail) ? 'el-input-error' : 'el-input']"
                v-model="resetInfo.email"
                :placeholder="$t('enter_email_address')"
              ></el-input>
            </div>
            <button @click="onSendResetEmail">{{ $t("send_code") }}</button>
            <button class="bottom-button" @click="onCancelForgetPassword">{{ $t("cancel") }}</button>
          </div>

          <div v-if="verificationCodeShow" class="operating">
            <p class="forgot-text">{{ $t("verification_code_text") }}</p>
            <p v-if="true" class="server-error-msg">
              <b>{{ this.resetErrorCode }}</b>
            </p>
            <div class="input_box">
              <span>{{ $t("verification_code") }}</span>
              <el-input
                :class="[(this.resetErrorCode) ? 'el-input-error' : 'el-input']"
                v-model="resetInfo.verificationCode"
                :placeholder="$t('enter_code')"
              ></el-input>
            </div>
            <button @click="onSendVerificationCode">{{ $t("confirm") }}</button>
            <button class="bottom-button" @click="onCancelForgetPassword">{{ $t("cancel") }}</button>
          </div>

          <div v-if="newPasswordShow" class="operating">
            <p class="forgot-text">{{ $t("new_password_text") }}</p>
            <p v-if="true" class="server-error-msg">
              <b>{{ this.resetErrorPassword }}</b>
            </p>
            <div class="input_box input_box_top">
              <span>{{ $t("new_password") }}</span>
              <el-input
                :class="[(this.resetErrorPassword) ? 'el-input-error' : 'el-input']"
                v-model="resetInfo.newPassword"
                :placeholder="$t('enter_password')"
                type="password"
              ></el-input>
            </div>
             <div class="input_box">
              <span>{{ $t("reenter_password") }}</span>
              <el-input
                :class="[(this.resetErrorPassword) ? 'el-input-error' : 'el-input']"
                v-model="resetInfo.newPasswordReenter"
                :placeholder="$t('reenter_password')"
                type="password"
              ></el-input>
            </div>
            <button @click="onSendNewPassword">{{ $t("confirm") }}</button>
            <button class="bottom-button" @click="onCancelForgetPassword">{{ $t("cancel") }}</button>
          </div>

          <div v-if="resetSuccessShow" class="operating">
            <p class="forgot-text">{{ $t("reset_success_1") }}</p>
            <p class="forgot-text">{{ $t("reset_success_2") }}</p>
            <button @click="onFinishReset">{{ $t("logIn") }}</button>
          </div>


        </div>

      </div>
    </div>
    <!-- <div class="login-img">
      <img src="../assets/img/login_pic1.png" alt="" />
    </div> -->

    <!-- <transition name="modal" v-if="showModal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            <p v-if="verificationCodeFail" class="red">
              {{ $t("codeNoMatch") }}
            </p>
            <div class="code">
              <img src="../assets/img/login_4.png" alt="">
              <el-input
                autofocus="true"
                placeholder="Verification Code"
                v-model="verification"
                v-on:input="sendVerificationCode(verification)"
              ></el-input>
            </div>
            <div class="btn_box">
              <el-button @click="cancelEnteringVerificationCode">{{
                $t("cancel")
              }}</el-button>
              <el-button
                style="float: right"
                @click="sendVerificationCode(verification)"
                >{{ $t("submit") }}</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </transition> -->
    <!-- <transition name="modal2" v-if="showChangeToNewPassword">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            <p>{{ $t("enterNewPassword") }}</p>
            <div class="code">
              <img src="../assets/img/login_5.png" alt="">
              <el-input
                autofocus="true"
                placeholder="New Password"
                type="password"
                v-model="newpassword"
              ></el-input>
            </div>
            <div class="btn_box box2">
              <el-button @click="resetPasswordRequest(newpassword)">{{
                $t("submit")
              }}</el-button>
            </div>
          </div>
        </div>
      </div>
    </transition> -->
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import Router from "../router";
import { isUserAuthenticated } from "../store/modules/cart";
export default {
  name: "login",
  data() {
    return {
      forgetPasswordShow: false,
      verificationCodeShow: false,
      newPasswordShow: false,
      resetSuccessShow: false,
      resetInfo: {
        email: "",
        verificationCode: "",
        newPassword: "",
        newPasswordReenter: "",
        token: "",
      },
      resetErrorEmail: "",
      resetErrorCode: "",
      resetErrorPassword: "",

      loginErrorEmail: "",
      loginErrorPassword: "",
      labelPosition: "top",
      formLabelAlign: {
        username: "",
        password: "",
      },
      email: "",
      login: true, //true showlogin; false forget password
      showModal: false,
      showChangeToNewPassword: false,
      newPasswordResetMessage: "",
      verification: "",
      tempToken: "",
      newpassword: "",
      couldNotFindEmail: false,
      verificationCodeFail: false,
    };
  },
  methods: {
    ...mapActions("auth", [
      "LoginRequest",
      "resetEmail",
      "sentVerificationCode",
      "resetPassword",
    ]),
    ...mapMutations("auth", ["updateErrorMessage"]),
    ForgotPassword() {
      (this.newPasswordResetMessage = ""),
        // this.loginErrorMessage = '',
        (this.login = !this.login);
    },
    Login(form) {
      this.loginErrorEmail = "";
      this.loginErrorPassword = "";
      this.updateErrorMessage(null);
      if (!form.username) {
        this.loginErrorEmail = this.$t("emailRequired");
      }
      if (!form.password) {
        this.loginErrorPassword = this.$t("passwordRequired");
      }
      if (form && form.username && form.password) {
        this.LoginRequest(form);
      }
    },
    // resetEmailRequest(email) {
    //   this.couldNotFindEmail = false;
    //   this.resetEmail(email)
    //     .then((res) => {
    //       this.tempToken = res.data;
    //       this.showModal = true;
    //     })
    //     .catch((err) => {
    //       this.couldNotFindEmail = true;
    //     });
    // },
    resetPasswordRequest(password) {
      this.resetPassword({ new_password: password, token: this.tempToken })
        .then((res) => {
          Object.assign(this.$data, this.$options.data.call(this));
          this.newPasswordResetMessage =
            "You have successfully reset your password";
        })
        .catch((err) => {
          alert(
            "err resetting the password, please contact AFM for more information"
          );
        });
    },
    sendVerificationCode(code) {
      this.verificationCodeFail = false;
      if (code.length < 6) {
        return;
      }
      this.sentVerificationCode({ code, token: this.tempToken })
        .then((res) => {
          this.showModal = false;
          this.tempToken = res.data;
          this.showChangeToNewPassword = true;
        })
        .catch((err) => {
          console.log("catching error sending verification code", err);
          this.verificationCodeFail = true;
        });
    },
    cancelEnteringVerificationCode() {
      this.showModal = false;
    },
    goToRegister() {
      this.$router.push("/register");
    },
    resetLoginForm() {
      this.loginErrorEmail = "";
      this.loginErrorPassword = "";
      // this.formLabelAlign.username = "";
      this.formLabelAlign.password = "";
    },
    resetForgetPassword() {
      this.forgetPasswordShow = false,
      this.verificationCodeShow = false,
      this.newPasswordShow = false,
      this.resetSuccessShow = false,
      this.resetInfo = {
        email: "",
        verificationCode: "",
        newPassword: "",
        newPasswordReenter: "",
        token: "",
      };
      this.resetErrorEmail = "";
      this.resetErrorCode = "";
      this.resetErrorPassword = "";
    },
    onEnableForgotPassword() {
      this.forgetPasswordShow = true;
      this.resetLoginForm();
    },
    onCancelForgetPassword() {
      this.resetForgetPassword();
    },
    onSendResetEmail() {
      if (!this.resetInfo.email) {
         this.resetErrorEmail = this.$t("emailRequired");
      } else {
        // this.couldNotFindEmail = false;
        this.resetEmail(this.resetInfo.email)
          .then((res) => {
            this.resetInfo.token = res.data;
            this.forgetPasswordShow = false;
            this.verificationCodeShow = true;
            // this.tempToken = res.data;
            // this.showModal = true;
          })
          .catch((err) => {
            this.resetInfo.token = "";
            this.resetErrorEmail = err.response.data;
            // this.resetErrorEmail = this.$t("emailNotFound");
            // this.couldNotFindEmail = true;
          });
      }
    },
    onSendVerificationCode() {
      if (!this.resetInfo.verificationCode) {
         this.resetErrorCode = this.$t("codeRequired");
      } else {
        //  this.verificationCodeFail = false;
        // if (code.length < 6) {
        //   return;
        // }
        this.sentVerificationCode({ code: this.resetInfo.verificationCode, token: this.resetInfo.token })
          .then((res) => {
            this.resetInfo.token = res.data;
            this.verificationCodeShow = false;
            this.newPasswordShow = true;
            // this.showModal = false;
            // this.tempToken = res.data;
            // this.showChangeToNewPassword = true;
          })
          .catch((err) => {            
            // this.resetErrorCode = err.response.data;
            this.resetErrorCode = this.$t("codeIncorrect");
            // this.verificationCodeFail = true;
          });
      }
    },
    onSendNewPassword() {
      if (!this.resetInfo.newPassword || !this.resetInfo.newPasswordReenter) {
        this.resetErrorPassword = this.$t("passwordRequired");
      } else if (this.resetInfo.newPassword !== this.resetInfo.newPasswordReenter) {
        this.resetErrorPassword = this.$t("passwordNotMatch");
      } else {
        this.resetPassword({ new_password: this.resetInfo.newPassword, token: this.resetInfo.token, code: this.resetInfo.verificationCode })
          .then((res) => {
            // Object.assign(this.$data, this.$options.data.call(this));
            this.newPasswordShow = false;
            this.resetSuccessShow = true;
            // this.newPasswordResetMessage = "You have successfully reset your password";
          })
          .catch((err) => {
            console.log("reset password error: ", err.response);
            this.resetErrorPassword = this.$t("server_error");
          });
      }
    },
    onFinishReset() {
      this.resetForgetPassword();
    },
    logInWithMedia(type) {},
  },
  beforeRouteLeave(to, from, next) {
    if (isUserAuthenticated()) {
      this.$store.dispatch("cart/getCart");
      this.$store.dispatch("auth/fetchCustomerInformation");
    } else {
      // this.$store.dispatch("cart/fetchCartProducts");
      // this.$store.dispatch("auth/fetchCustomerInformation");
    }
    next();
  },
  mounted() {},
  watch: {
    $route(to, from) {
      this.resetLoginForm();
      this.resetForgetPassword();
    },
  },
  computed: mapState({
    loginErrorMessage: (state) => state.auth.loginErrorMessage,
  }),
};
</script>
​
​
<style scoped lang="less">
@import "../assets/css/public";
@import "../assets/css/login";
</style>


// WEBPACK FOOTER //
// src/view/login.vue